export default ngModule => {
  require('./currency')(ngModule);
  require('./text')(ngModule);
}



// WEBPACK FOOTER //
// ./src/filters/index.js